module.exports = __webpack_public_path__ + "static/media/about.4a1fecd4.png";